import { useT } from '../lib/i18n';

interface Props<T extends string> {
  groups: Array<{ id: T; label: string; count: number }>;
  active: T | 'all';
  onChange: (id: T | 'all') => void;
  total: number;
}

/** Group filter for a single rail, replacing one rail per group. */
export function FilterChips<T extends string>({ groups, active, onChange, total }: Props<T>) {
  const t = useT();
  return (
    <div className="row row--wrap" style={{ gap: 6 }}>
      <button
        type="button"
        className={`chip ${active === 'all' ? 'is-on' : ''}`}
        onClick={() => onChange('all')}
      >
        {t('filter.all')} <span style={{ opacity: 0.65 }}>{total}</span>
      </button>
      {groups.map((g) => (
        <button
          key={g.id}
          type="button"
          className={`chip ${active === g.id ? 'is-on' : ''}`}
          onClick={() => onChange(g.id)}
        >
          {g.label} <span style={{ opacity: 0.65 }}>{g.count}</span>
        </button>
      ))}
    </div>
  );
}
